/* eslint-disable no-nested-ternary */
import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-bottom: 16px;
  span.textarea-error {
    display: flex;
    align-items: center;
    margin-top: var(--flora--space-1);
    color: var(--flora--colors-medium-light-1);
    font-family: var(--flora--fonts-secondary);
    font-size: var(--flora--fontSizes-sm);
    height: 16px;
    & svg {
      margin-right: var(--flora--space-1);
      height: 16px;
    }
  }
`;

export const Textarea = styled.div<{
  invalid: boolean;
  focused: boolean;
  hasValue: boolean;
}>`
  border: 1px solid
    ${props =>
      props.invalid || props.focused ? '#fff' : props.theme.colors.text};
  border-radius: 4px;
  width: 100%;
  height: fit-content;
  padding: 16px 12px 12px;
  background-color: #fff;
  box-shadow: ${props =>
    props.invalid
      ? `inset 0 0 0 2px ${props.theme.colors.error}`
      : props.focused
      ? `inset 0 0 0 2px ${props.theme.colors.main}`
      : ''};

  &::focus {
    border-color: ${props =>
      props.invalid ? props.theme.colors.error : props.theme.colors.main};
  }

  span.textarea-label {
    font-size: var(--flora--fontSizes-md);
    font-style: normal;
    font-weight: 500;
    line-height: 13px;
    color: ${props =>
      props.focused && !props.hasValue
        ? props.theme.colors.main
        : props.theme.colors.text};
    & span {
      color: ${props =>
        props.hasValue ? props.theme.colors.text : props.theme.colors.error};
    }
  }
  textarea {
    margin-top: 8px;
    border: 0px;
    width: 100%;
    min-height: 150px;
    border: none;
    outline: none;
    resize: none;
  }
`;
